import "./FineHeader.css";

import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

import { FineType } from "../../../models/fineModels";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavigateFunction } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { setCurrentStep } from "../../../store/fine/fineActions";

interface FineHeaderProps {
  navigate: NavigateFunction;
}

const FineHeader = ({ navigate }: FineHeaderProps) => {
  const [steps, setSteps] = useState<string[]>([]);
  const fineType = useAppSelector((state) => state.fine.type);
  const currentStep = useAppSelector((state) => state.fine.currentStep);
  let mobileStepContainer: HTMLElement | null;

  useEffect(() => {
    if (fineType === FineType.NONWARRANT) {
      setSteps(["Fine Details", "Payment"]);
    } else {
      setSteps(["Fine Details", "Agreement", "Payment"]);
    }
    if (window.innerWidth <= 480) {
      mobileStepContainer = document.getElementById("mobile-step-counter");
      mobileStepContainer!.style.borderTopColor = "#e97700";
      mobileStepContainer!.style.borderRightColor = "#e97700";
    }
  }, [fineType]);

  useEffect(() => {
    mobileStepContainer = document.getElementById("mobile-step-counter");
    if (mobileStepContainer) {
      if (currentStep === 2 && steps.length === 2) {
        mobileStepContainer!.style.borderBottomColor = "#e97700";
        mobileStepContainer!.style.borderLeftColor = "#e97700";
      }
      if (currentStep === 2 && steps.length === 3) {
        mobileStepContainer!.style.borderBottomColor = "#e97700";
      }
      if (currentStep === 3 && steps.length === 3) {
        mobileStepContainer!.style.borderLeftColor = "#e97700";
      }
    }
  }, [currentStep]);

  return (
    <div className="fine-header-container">
      {window.innerWidth > 480 ? (
        <DesktopContent
          steps={steps}
          currentStep={currentStep}
          navigate={navigate}
        />
      ) : (
        <MobileContent
          steps={steps}
          currentStep={currentStep}
          navigate={navigate}
        />
      )}
    </div>
  );
};

interface ContentProps {
  steps: string[];
  currentStep: number;
  navigate: NavigateFunction;
}

const DesktopContent = ({ steps, currentStep, navigate }: ContentProps) => {
  const dispatch = useAppDispatch();
  const onBackClicked = () => {
    if (currentStep > 1) {
      dispatch(setCurrentStep(currentStep - 1));
    } else {
      navigate("/");
    }
  };
  return (
    <>
      <div className="step-counter-container">
        <div className="back-button" onClick={() => onBackClicked()}>
          <FontAwesomeIcon icon={faArrowLeft} size="2x" color="#18283c" />
          <p>Back</p>
        </div>

        {steps.map((e, index) => (
          <React.Fragment key={index}>
            <div
              className="step-number"
              style={{
                background: currentStep === index + 1 ? "#EB7D24" : "#16293B",
              }}
            >
              {index + 1}
            </div>
            <p
              className="step-name"
              style={{
                fontWeight: currentStep === index + 1 ? "bold" : "normal",
              }}
            >
              {e}
            </p>
            {index + 1 !== steps.length && <div className="step-divider" />}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

const MobileContent = ({ steps, currentStep, navigate }: ContentProps) => {
  const dispatch = useAppDispatch();
  const onBackClicked = () => {
    if (currentStep > 1) {
      dispatch(setCurrentStep(currentStep - 1));
    } else {
      navigate("/");
    }
  };
  return (
    <div className="mobile-content">
      <div className="back-button" onClick={() => onBackClicked()}>
        <FontAwesomeIcon icon={faArrowLeft} size="2x" color="#18283c" />
        <p>Back</p>
      </div>

      <div className="mobile-step-counter" id="mobile-step-counter">
        {`${currentStep}/${steps.length}`}
      </div>
      <p className="fine-header-title">{steps[currentStep - 1]}</p>
    </div>
  );
};

export default FineHeader;
